import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private loginService:LoginService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = localStorage.getItem('ACCESS_TOKEN');
    if(token != null){
      this.loginService.refresh();
    }
    if ((!this.loginService.hasAnyRole(['ADMIN','SELLER-ADMIN','SELLER','CASHIER-SELLER','CASHIER']) && this.loginService.isAuthenticateds())|| !this.loginService.isAuthenticateds()) {
      this.router.navigate(['/user-pages/login']);
      return false;
    } else if(this.loginService.hasAnyRole(['SELLER','CASHIER-SELLER','CASHIER'])){
      this.router.navigate(['/orders/orders-carousel']);
      return false;
    } else if(this.loginService.hasAnyRole(['SELLER-ADMIN'])){
      this.router.navigate(['/bank-reports/changes']);
      return false;
    }else{
      return true;
    }
  }

}
